import { Box, IconButton, InputAdornment } from '@mui/material';
import { Form, Formik } from 'formik';
import { useState } from 'react';
import Logo from '../../../shared/components/common/logo';
import InputWrapper from '../../../shared/formUtilities/useInput';
import TextWrapper from '../../../shared/formUtilities/useTextWrapper';
import { ForgotPasswordSchema } from '../../../shared/validations/schema';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { forgotPassword } from '../../../services/authService';
import { Toaster } from '../../../shared/components/common/toaster';

export const ForgotPassword = () => {
	const [loading, setLoading] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const navigate = useNavigate();

	const onSubmit = (values) => {
		setLoading(true);
		forgotPassword(values)
			.then((resp) => {
				setLoading(false);
				setIsSuccess(true);
			})
			.catch((err) => {
				Toaster({ msg: 'Email not found!' });
				setLoading(false);
				setIsSuccess(false);
			});
	};

	return (
		<>
			<div className="flex  flex-col flex-auto items-center sm:justify-center min-w-0 h-full bg-gray">
				<div className="w-full relative flex sm:w-auto sm:rounded-2xl sm:shadow-md sm:bg-card bg-white">
					<div className="w-full sm:py-12 sm:px-12 max-w-[400px] sm:w-[400px] mx-auto sm:mx-0">
						<div className="w-full flex flex-col flex-0 relative">
							<div className="w-24 absolute -top-8 -left-4 mb-5">
								<Logo sx={{ height: 100, width: 100 }} />
							</div>
							<TextWrapper
								classList={`text-2xl font-bold pt-10 !text-center ${
									isSuccess ? '!text-primary' : ''
								}`}
								type="h5"
								text={
									!isSuccess
										? 'Enter your email address'
										: 'Email sent successfully'
								}
							/>
						</div>
						{!isSuccess ? (
							<>
								<Formik
									initialValues={{
										email: '',
									}}
									enableReinitialize={true}
									validationSchema={ForgotPasswordSchema}
									validateOnMount={true}>
									{(formik) => {
										return (
											<Form className="mt-6">
												<InputWrapper
													key={'email'}
													label="Email"
													size="small"
													error={formik.errors.email && formik.touched.email}
													helperText={
														formik.errors.email && formik.touched.email
															? formik.errors.email
															: ''
													}
													variant="outlined"
													fullWidth={true}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton className="!bg-transparent text-primary">
																	<EmailOutlinedIcon className="text-md"></EmailOutlinedIcon>
																</IconButton>
															</InputAdornment>
														),
													}}
													type={'email'}
													name="email"></InputWrapper>
												<Box className="grid grid-cols-2 gap-4">
													<ButtonWrapper
														variant={'outlined'}
														onClick={() => {
															navigate(-1);
														}}
														icon={<ArrowBackIcon></ArrowBackIcon>}
														label="Back"
														classList="w-full !mt-8"
														type="button"></ButtonWrapper>
													<ButtonWrapper
														icon={<ForwardToInboxIcon></ForwardToInboxIcon>}
														loading={loading}
														label="Send Mail"
														classList="w-full !mt-8"
														onClick={() => {
															formik.setFieldTouched('email', true);
															if (formik.isValid) {
																onSubmit(formik.values);
															}
														}}></ButtonWrapper>
												</Box>
											</Form>
										);
									}}
								</Formik>
							</>
						) : (
							<>
								<Box className="grid grid-flow-row gap-6 mt-4">
									<TextWrapper
										type="span"
										classList="caption"
										text="If you have an account with us, we will email you a password reminder"></TextWrapper>
									<ButtonWrapper
										variant={'outlined'}
										onClick={() => {
											navigate(-1);
										}}
										icon={<ArrowBackIcon></ArrowBackIcon>}
										label="Back to login"
										classList="w-full"
										type="button"></ButtonWrapper>
								</Box>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
};
